import OrderItem from '../OrderItem';
import './OrdersList.css';

const OrdersList = ({ orders }) => {
  return (
    <div className="orders-list">
      {orders.length === 0 ? (
        <div className="no-orders">
          <p>No orders found.</p>
        </div>
      ) : (
        orders.map((order) => (
          <OrderItem key={order.id} order={order} />
        ))
      )}
    </div>
  );
};

export default OrdersList;
